import React from 'react';
import { Link } from 'react-router-dom';
import { FaGlobeAmericas, FaMicrophone, FaLock, FaDownload, FaVideo } from 'react-icons/fa';
import LanguageBadges from '../components/LanguageBadges';
import '../styles/HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Dub your videos into any language, right on your computer</h1>
            <p className="subtitle">Dubbah is a free Mac app that translates and re-voices your videos in 14 languages. Your files never leave your machine and are never used to train AI.</p>
            <div className="hero-buttons">
              <a href="https://petvids.s3.us-east-2.amazonaws.com/dubbah/Dubbah-Studio.dmg" className="primary-button">
                <FaDownload className="icon-margin-right" /> Download for Mac
              </a>
              <span className="hero-note">Free &middot; macOS 13+ &middot; Apple Silicon &amp; Intel</span>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2>How it works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon"><FaVideo /></div>
              <h3>Drop in your video</h3>
              <p>Drag any video file into Dubbah. MP4, MOV, or any common format.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon"><FaGlobeAmericas /></div>
              <h3>Pick your language</h3>
              <p>Choose one language or many. Dubbah handles translation and voice matching automatically.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon"><FaMicrophone /></div>
              <h3>Review and export</h3>
              <p>Preview the result, edit any lines you want to tweak, then export your finished video.</p>
            </div>
          </div>
        </div>
      </section>

      {/* What you get */}
      <section className="features">
        <div className="container">
          <h2>What you get</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h3>14 languages</h3>
              <p>Spanish, Mandarin, Hindi, Arabic, Japanese, French, German, Korean, Portuguese, Italian, Polish, Turkish, Tamil, and English.</p>
            </div>
            <div className="feature-item">
              <h3>Voice cloning</h3>
              <p>Dubbah matches the original speaker's voice in the target language so your content sounds natural, not robotic.</p>
            </div>
            <div className="feature-item">
              <h3>Full editing control</h3>
              <p>Review every translated line before export. Change wording, adjust timing, or re-generate individual segments.</p>
            </div>
            <div className="feature-item">
              <h3>Works offline</h3>
              <p>After the initial setup, Dubbah runs without an internet connection. Dub on a plane, on set, wherever.</p>
            </div>
            <div className="feature-item">
              <h3>No account required</h3>
              <p>Download the app and start dubbing. No sign-up, no email, no login.</p>
            </div>
            <div className="feature-item">
              <h3>Completely free</h3>
              <p>No subscriptions, no per-minute fees, no hidden costs. Dub as many videos as you want.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Language Section */}
      <section className="languages">
        <div className="container">
          <h2>Supported languages</h2>
          <LanguageBadges />
        </div>
      </section>

      {/* CTA Section */}
      <section className="download-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to go global?</h2>
            <p>Download Dubbah and dub your first video today.</p>
            <a href="https://petvids.s3.us-east-2.amazonaws.com/dubbah/Dubbah-Studio.dmg" className="primary-button">
              <FaDownload className="icon-margin-right" /> Download for Mac
            </a>
            <p className="cta-fine-print">Free &middot; macOS 13+ &middot; Apple Silicon &amp; Intel</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
